import { ApiKeys, Service, getApiKey } from '../environment';

import { GOOGLE_MAPS_API_BASE_URL } from './constants';

export const getGoogleMapsApiKey = () => {
  return getApiKey('googleMaps', ApiKeys.get(Service.googleMaps));
};

export const getGoogleApiSrcPath = () => {
  const googleMapsApiKey = getGoogleMapsApiKey();
  return `${GOOGLE_MAPS_API_BASE_URL}/js?key=${googleMapsApiKey}&libraries=places`;
};
